<template>
    <div>
        <li class="m_li" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <a href="javascript:;" @click="user_faq" class="f f20"><i class="iconfont icon-yijianfankui" style="color:#ffffff;font-size:22px;"></i></a>
            <p class="r_av m_tr" :style="active">意见反馈<em class="r_vt">◆</em></p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
        }
    },
    methods:{
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li";
            this.active="opacity: 0; right: 70px; display: none;"
        },
        user_faq(){
            //指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/user_faq')
			}else{
				this.$router.push('/login')
			}
		},
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-yijian.vue